import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 md:px-20 text-gray-800">
      <div className="max-w-8xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <h1 className="text-3xl font-bold text-center text-indigo-700 mb-6">
          Privacy Policy
        </h1>
        <p className="text-center text-sm text-gray-500 mb-10">
          Privacy Policy for <strong>Sridanth™ (Sri Sai Dental Aesthetics)</strong>  
          <br />
          <span className="italic">Last Updated: 2025</span>
        </p>

        {/* 1. Introduction */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            1. Introduction
          </h2>
          <p className="leading-relaxed">
            Welcome to <strong>Sridanth</strong>. We are committed to protecting your privacy. 
            This policy explains how we collect, use, and safeguard your personal information 
            when you visit <em>[Your Website URL]</em> and make a purchase.
          </p>
        </section>

        {/* 2. Information We Collect */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            2. Information We Collect
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Personal Information:</strong> When you place an order, we collect information such as your name, shipping address, email address, and phone number.
            </li>
            <li>
              <strong>Payment Information:</strong> All payments are processed securely by our payment gateway (e.g., Razorpay). We do not store your credit/debit card details on our servers.
            </li>
            <li>
              <strong>Technical Data:</strong> We automatically collect your IP address and browsing behavior through cookies to improve our site's functionality.
            </li>
          </ul>
        </section>

        {/* 3. How We Use Your Information */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            3. How We Use Your Information
          </h2>
          <p className="mb-2">We use your information to:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Process and fulfill your orders.</li>
            <li>Communicate with you about your order (e.g., confirmations, shipping updates).</li>
            <li>Provide customer support.</li>
            <li>(If you opt-in) Send you marketing emails about new products and offers. You can unsubscribe at any time.</li>
          </ul>
        </section>

        {/* 4. Data Sharing */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            4. Data Sharing
          </h2>
          <p className="mb-2">
            We do not sell or rent your personal data. We only share it with third parties essential for providing our services, such as:
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Shipping partners (e.g., Delhivery, India Post) to deliver your order.</li>
            <li>Payment gateways (e.g., Razorpay) to process transactions securely.</li>
          </ul>
        </section>

        {/* 5. Your Rights */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            5. Your Rights
          </h2>
          <p className="leading-relaxed">
            You have the right to access, correct, or delete the personal information we hold about you. 
            To do so, please contact us at <a href="mailto:support@sridanth.com" className="text-indigo-600 underline">support@sridanth.com</a>.
          </p>
        </section>

        {/* 6. Data Security */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            6. Data Security
          </h2>
          <p className="leading-relaxed">
            We implement appropriate security measures to protect your data. However, no method of transmission 
            over the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        {/* 7. Changes to This Policy */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            7. Changes to This Policy
          </h2>
          <p className="leading-relaxed">
            We may update this policy periodically. The latest version will always be posted on our website.
          </p>
        </section>

        {/* 8. Contact Us */}
        <section>
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            8. Contact Us
          </h2>
          <p className="leading-relaxed">
            For any privacy-related questions, please contact us at:{" "}
            <a href="mailto:support@sridanth.com" className="text-indigo-600 underline">
              support@sridanth.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
